export const GET_PLANS = "getPlans";
export const GET_SINGLE_PLAN = "getSinglePlan";
export const SEND_PLAN_PAYMENT = "sendPlanPayment";